import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ImageViewerDialog = ({ open, onClose, imageUrl, fileName }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                    overflow: "hidden",
                },
            }}
        >
            <DialogTitle
                sx={{
                    background: "linear-gradient(135deg, #1E3A5F 0%, #2E5A8F 100%)",
                    color: "#fff",
                    fontFamily: "Inter",
                    fontWeight: 600,
                    fontSize: "18px",
                    padding: "20px 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <Typography sx={{ fontFamily: "Inter", fontWeight: 600, fontSize: "18px" }}>
                    {fileName}
                </Typography>
                <IconButton onClick={onClose} sx={{ color: "#fff" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ padding: "24px", textAlign: "center", backgroundColor: "#F9FAFB" }}>
                <Box
                    component="img"
                    src={imageUrl}
                    alt={fileName}
                    sx={{
                        maxWidth: "100%",
                        maxHeight: "70vh",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    }}
                />
            </DialogContent>
            <DialogActions sx={{ padding: "16px 24px", justifyContent: "center" }}>
                <Button
                    onClick={() => window.open(imageUrl, "_blank")}
                    sx={{
                        textTransform: "none",
                        fontFamily: "Inter",
                        fontWeight: 500,
                        padding: "10px 24px",
                        borderRadius: "8px",
                        background: "linear-gradient(135deg, #1E3A5F 0%, #2E5A8F 100%)",
                        color: "#fff",
                        "&:hover": {
                            background: "linear-gradient(135deg, #2E5A8F 0%, #1E3A5F 100%)",
                        },
                    }}
                >
                    Open in New Tab
                </Button>
                <Button
                    onClick={onClose}
                    sx={{
                        textTransform: "none",
                        fontFamily: "Inter",
                        fontWeight: 500,
                        padding: "10px 24px",
                        borderRadius: "8px",
                        border: "1px solid #D0D5DD",
                        color: "#667085",
                        "&:hover": {
                            backgroundColor: "#F9FAFB",
                        },
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImageViewerDialog;
